module.exports = __webpack_public_path__ + "img/tractor-photo-03.c22089c4.jpeg";